import { DndContext, type DragEndEvent, MouseSensor, TouchSensor, type UniqueIdentifier, useSensor } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { SortableContext } from '@dnd-kit/sortable';
export const SortableContainer = ({
  onDragEnd,
  items,
  children
}: {
  onDragEnd: (event: DragEndEvent) => void;
  items: UniqueIdentifier[];
  children: React.ReactNode;
}) => {
  const mouseSensor = useSensor(MouseSensor, {
    activationConstraint: {
      // 상하 50px 이상 드래그 시 활성화
      distance: {
        x: 0,
        y: 50
      }
    }
  });
  const touchSensor = useSensor(TouchSensor, {
    activationConstraint: {
      delay: 100,
      tolerance: 10
    }
  });
  return <DndContext sensors={[mouseSensor, touchSensor]} modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd} data-sentry-element="DndContext" data-sentry-component="SortableContainer" data-sentry-source-file="SortableContainer.tsx">
      <SortableContext items={items} data-sentry-element="SortableContext" data-sentry-source-file="SortableContainer.tsx">
        <div className="relative flex flex-col gap-2xs">{children}</div>
      </SortableContext>
    </DndContext>;
};